export default {
  sentence1: 'Você pode fazer a validação de renda online. É seguro e leva menos de dois minutos.',
  sentence2: 'A senha é somente pare leitura, é impossível realizarmos qualquer movimentação financeira na sua conta',
};
